<template>
  <div>
    <div class="wrapper-content w-100 position-relative pt-4">
      <div>
        <LmTreeSelect
        :label="$t('data_origin')"
        :placeholder="$t('select_option')"
        @input="!isOnEditMode ? inputOriginData() : null"
        v-model="dataOriginSelected"
        :options="dataOrigin"
        :help="$t('help_data_origin')"
        :disabled="isOnEditMode ? true : false"
        />
        <div v-if="dataOriginSelected || isOnEditMode">
          <LmTextInput :label="$t('form_alias')" v-model="form.alias" :help="$t('help_alias')"  />
          <LmTextInput :label="$t('label_titulo_listado')" v-model="listBuilderTitleList" :help="$t('help_titulo_listado')"  />

          <LmCheckbox
            class="mb-2"
            labelSingle="Es un listado seleccionable"
            v-model="form.selectable"
            @input="onTableSelectable"
          />

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-search`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-search`">{{ $t('titulo_ventana_busqueda_inicial') }}</h6>
              <b-badge variant="light" class="badge d-none">0</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-search`"
          class="p-4 border border-top-0 rounded-lg"
          >
            <div class="mt-2">
              <p>{{ $t('description_busqueda_inicial') }}</p>
              <div class="d-flex align-items-center">
                <LmTextArea class="flex-grow-1" :label="$t('label_busqueda_inicial')" v-model="form.gqlVariables.q" :help="$t('help_busqueda_inicial')" @input="refreshListBuilder" :maxLength="4000"/>
                <LmQueryBuilder
                  class="ml-4"
                  :settings="queryBuilderSettings"
                  @input="onUpdateGqlVariablesQ"
                />
              </div>
              <div class="d-flex align-items-center">
                <LmTextArea  class="flex-grow-1" :label="$t('label_busqueda_meta')" v-model="form.metaSearch" :help="$t('help_busqueda_meta')" @input="refreshListBuilder" :maxLength="40000"/>
                <LmQueryBuilder
                  class="ml-4"
                  :settings="queryBuilderSettings"
                  @input="onUpdateMetaSearch"
                />
              </div>
              <LmTreeSelect :label="$t('label_ordenar_por')" placeholder="updatedAt__desc" @input="inputSortData" v-model="dataSortSelected" :options="dataSort" :help="$t('help_ordenar_por')" />
            </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-columns`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-columns`">{{ $t('titulo_columnas') }}</h6>
              <b-badge variant="light" class="badge d-none">0</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-columns`"
          class="pl-4 pt-4 pb-3 border border-top-0 rounded-lg"
          >
          <div>
            <b-tabs content-class="mt-3" align="center">
              <b-tab :title="$t('titulo_columns_listado')" active>
                <div class="mt-2">
                  <b-form-group
                    :label="$t('label_columnas')"
                    v-slot="{ ariaListado }"
                  >
                    <b-form-checkbox
                      v-for="(item, index) in form.items"
                      v-model="form.visibleFields"
                      name="itemsColumns"
                      :id="'col-listado-'+index"
                      :key="item.name"
                      :value="item.name"
                      @change="refreshListBuilder"
                      :aria-describedby="ariaListado"
                    >
                      {{ nameColumn(item.name, item.description) }}
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </b-tab>
              <b-tab :title="$t('titulo_columns_busqueda')">
                <div class="mt-2">
                  <b-form-group
                    :label="$t('label_columnas_busqueda')"
                    v-slot="{ ariaBusqueda }"
                  >
                    <b-form-checkbox
                      v-for="(item, index) in form.items"
                      v-model="form.searchOnFieldsToSelected"
                      name="itemsColumns"
                      :id="'col-busqueda-'+index"
                      :key="item.name"
                      :value="item.name"
                      @input="refreshListBuilder"
                      :aria-describedby="ariaBusqueda"
                    >
                      {{ item.description }}
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-buttons`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-buttons`">{{ $t('titulo_ventana_botones') }}</h6>
              <b-badge variant="light" class="badge" v-if="form.buttonLinks.length">{{ form.buttonLinks.length }}</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-buttons`"
          class="p-4 pl-4 pt-4 pb-3 border border-top-0 rounded-lg"
          >
            <div class="mt-2">
              <LmSelect
                label="Tipo de botón"
                v-model="buttons.type"
                :options="{
                  disabledOption: $t('disabled_option'),
                  content: [
                    { value: 'redirect', text: 'Redirección' },
                    { value: 'action', text: 'Acción' }
                  ]
                }"
              />
              <LmTextInput v-model="buttons.value" :label="$t('label_valor')" :placeholder="$t('placeholder_valor')" :help="getHelp('lmButtonLink', 'value')" />
              <LmTextInput v-if="buttons.type === 'redirect'" v-model="buttons.to" :label="$t('label_to')" :placeholder="$t('placeholder_to')" :help="getHelp('lmButtonLink', 'to')" />
              <LmTextInput v-if="buttons.type === 'redirect'" v-model="buttons.endpointToValidateVisibility" :label="$t('label_endpointToValidateVisibility')" :placeholder="$t('placeholder_endpointToValidateVisibility')" :help="getHelp('lmButtonLink', 'endpointToValidateVisibility')" />

              <LmTextInput
                v-if="buttons.type === 'action'"
                label="Enpoint para el request"
                v-model="buttons.requestEndpoint"
              />
              <LmCheckbox
                v-if="buttons.type === 'action'"
                labelSingle="El request requiere confirmación"
                v-model="buttons.requestConfirmation"
              />

              <label for="buttons-show">
                Opciones del botón
              </label>
              <b-form-checkbox
              id="buttons-show"
              v-model="buttons.show"
              :value="true"
              :unchecked-value="false"
              >
                {{ $t('label_mostrar') }}
              </b-form-checkbox>

              <b-form-checkbox
              id="buttons-disabled"
              v-model="buttons.disabled"
              :value="true"
              :unchecked-value="false"
              >
                {{ $t('label_checkbox_deshabilitar') }}
              </b-form-checkbox>
              <b-form-checkbox
              v-if="form.selectable && buttons.type === 'action'"
              id="buttons-on-selectable"
              v-model="buttons.enableOnSelectedRows"
              :value="true"
              :unchecked-value="false"
              >
                Habilitado al seleccionar filas
              </b-form-checkbox>
              <label for="buttons-color" class="mt-2 mr-2"> {{ $t('label_color') }} </label>

              <swatches
              id="buttons-color"
              v-model="buttons.buttonColor"
              :swatches="swatches"
              :trigger-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
              :swatch-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
              popover-to="left"
              class="d-block"
            ></swatches>

            <LmButton type="button" buttonClass="btn-primary" :value="$t('btn_agregar_boton')"
                lmButtonRootWrapperClass="d-inline-block mr-1 mt-4 mb-4" lmButtonWrapperClass="col"
                @click.native="addButonLink" />

              <draggable
                  class="col-12"
                  v-model="form.buttonLinks"
                  @start="drag=true"
                  @end="drag=false"
                  animation="150"
                  handle=".handle"
                  @input="refreshListBuilder"
                  >
                  <!-- Draggable buttons -->
                    <div v-for="(item, index) in form.buttonLinks" :key="index" class="mb-2">
                      <header  class="d-flex justify-content-between align-items-center text-white px-3 handle shadow rounded-lg" :class="form.buttonLinks[index].buttonClass">
                        <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                        <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-buttons-${index}`">{{ item.value }}</h6>
                        <div class="circle d-none justify-content-center align-items-center">{{index}}</div>
                        <div class="d-flex align-items-center">
                          <font-awesome-icon v-b-toggle="`collapse-buttons-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                          <font-awesome-icon  class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeElements(index, 'buttonLinks')" />
                        </div>
                      </header>
              <b-collapse
              :id="`collapse-buttons-${index}`"
              class="p-4 border border-top-0 rounded-lg"
              >
                <LmTextInput v-model="form.buttonLinks[index].value" :label="$t('label_valor')" :placeholder="$t('placeholder_valor')" @input="refreshListBuilder" :help="getHelp('lmButtonLink', 'value')" />
                <LmTextInput v-model="form.buttonLinks[index].to" :label="$t('label_to')" :placeholder="$t('placeholder_to')" @input="refreshListBuilder" :help="getHelp('lmButtonLink', 'to')" v-if="'!type' in item || item.type === 'redirect'" />
                <LmTextInput v-model="form.buttonLinks[index].endpointToValidateVisibility" :label="$t('label_endpointToValidateVisibility')" @input="refreshListBuilder" :placeholder="$t('placeholder_endpointToValidateVisibility')" :help="getHelp('lmButtonLink', 'endpointToValidateVisibility')" v-if="'!type' in item || item.type === 'redirect'" />

                <LmTextInput
                  v-if="'type' in item || item.type === 'action'"
                  label="Enpoint para el request"
                  v-model="form.buttonLinks[index].requestEndpoint"
                />
                <LmCheckbox
                  v-if="'type' in item || item.type === 'action'"
                  labelSingle="El request requiere confirmación"
                  v-model="form.buttonLinks[index].requestConfirmation"
                />

                <label for="buttons-show">
                  Opciones del botón
                </label>
                <b-form-checkbox
                :id="`buttons-show-${index}`"
                v-model="form.buttonLinks[index].show"
                :value="true"
                :unchecked-value="false"
                @input="refreshListBuilder"
                >
                  {{ $t('label_mostrar') }}
                </b-form-checkbox>

                <b-form-checkbox
                :id="`buttons-disabled-${index}`"
                v-model="form.buttonLinks[index].disabled"
                :value="true"
                :unchecked-value="false"
                @input="refreshListBuilder"
                >
                  {{ $t('label_checkbox_deshabilitar') }}
                </b-form-checkbox>
                <b-form-checkbox
                v-if="'type' in item || item.type === 'action'"
                id="buttons-on-selectable"
                v-model="form.buttonLinks[index].enableOnSelectedRows"
                :value="true"
                :unchecked-value="false"
                >
                  Habilitado al seleccionar filas
                </b-form-checkbox>

                <label for="buttons-color" class="mt-2 mr-2"> {{ $t('label_color') }} </label>

                <swatches
                :id="`buttons-color-${index}`"
                v-model="form.buttonLinks[index].buttonColor"
                @input="inputButtonColor(index)"
                :swatches="swatches"
                :trigger-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
                :swatch-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
                popover-to="left"
                class="d-block"
              ></swatches>

              </b-collapse>
                    </div>
              </draggable>
          </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-pages`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-pages`">{{ $t('titulo_ventana_paginado') }}</h6>
              <b-badge variant="light" class="badge d-none">0</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-pages`"
          class="p-4 pl-4 py-3 border border-top-0 rounded-lg"
          >
            <div class="mt-2">
              <LmNumberInputV2 :label="$t('label_pagina')" v-model="form.page" :help="$t('help_pagina')" @input="refreshListBuilder" />
              <LmNumberInputV2 :label="$t('label_perpage')" v-model="form.itemsPerPage" :help="$t('help_perpage')" @input="refreshListBuilder" />
            </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-actions`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-actions`">{{ $t('titulo_ventana_acciones') }}</h6>
              <b-badge variant="light" class="badge" v-if="form.lmPathActions.length || form.lmModalActions.length">{{ (form.lmPathActions.length + form.lmModalActions.length) }}</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-actions`"
          class="p-4 pl-4 py-3 border border-top-0 rounded-lg"
          >
            <div class="mt-2">

            <b-tabs content-class="mt-3" align="center">
              <b-tab :title="$t('name_path')" :active="form.action.lmPathActions" @click="clickTabsActions('lmPathActions')">
              <LmTextInput ref="to" v-model="action.to" :label="$t('label_action_to')" :help="getHelp('lmPathActions', 'to')" />
              <LmTextInput ref="tooltip" v-model="action.tooltip" :label="$t('label_action_tooltip')" :placeholder="$t('placeholder_action_tooltip')" :help="getHelp('lmPathActions', 'tooltip')" />
              <LmTextInput ref="font awesome icon" v-model="action.fontAwesomeIcon" :label="$t('label_modal_fontAwesomeIcon')" :help="getHelp('lmPathActions', 'fontAwesomeIcon')"
              placeholder="edit" />
              {{ $t('label_modal_fontAwesomeIcon_small') }} <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>
              </b-tab>
              <b-tab :title="$t('name_modal')" :active="form.action.lmModalActions" @click="clickTabsActions('lmModalActions')">
                  <LmTextInput ref="modalEndpoint" v-model="modal.endpoint" :placeholder="$t('placeholder_modal_endpoint')"  :label="$t('label_modal_endpoint')" :help="getHelp('lmModalActionsArgument', 'endpoint')" />
                  <LmSelect v-model="modal.requestMethod" :label="$t('label_modal_requestMethod')" :options="{
                      disabledOption: $t('disabled_option'),
                      content: [
                        { value: 'POST', text: 'POST' },
                        { value: 'PUT', text: 'PUT' },
                        { value: 'DELETE', text: 'DELETE' }
                      ]
                    }"
                    :help="getHelp('lmModalActionsArgument', 'requestMethod')"
                    />
                  <LmNumberInputV2 ref="modalDelayAfterSubmit" v-model="modal.delayAfterSubmit" :placeholder="$t('placeholder_modal_delayAfterSubmit')"  :label="$t('label_modal_delayAfterSubmit')" :help="getHelp('lmModalActionsArgument', 'delayAfterSubmit')" />
                  <LmTextInput ref="modalTitle" v-model="modal.title" :placeholder="$t('placeholder_modal_title')"  :label="$t('label_modal_title')" :help="getHelp('lmModalActionsArgument', 'title')" />
                  <LmTextInput ref="modalTooltip" v-model="modal.tooltip" :placeholder="$t('placeholder_modal_tooltip')" :label="$t('label_modal_tooltip')" :help="getHelp('lmModalActionsArgument', 'tooltip')" />
                  <LmEditor ref="modalMessage" @onUpdate="modal.message = $event" :contentProps="modal.message" :placeholder="$t('placeholder_modal_message')" :label="$t('label_modal_message')" :activeTable="false" :help="getHelp('lmModalActionsArgument', 'message')" />
                  <input type="checkbox" id="isComment" name="isComment"
                    v-model="modal.isComment" class="mb-4 mt-2">
                  <label for="isComment" class="ml-1">{{ $t('label_isComment') }}</label>
                  <div v-if="modal.isComment" class=" px-3">
                    <LmTextInput ref="modalComment" v-model="modal.labelComment" :placeholder="$t('placeholder_modal_labelComment')" :label="$t('label_modal_labelComment')" :help="getHelp('lmModalActionsArgument', 'labelComment')"/>
                    <input type="checkbox" id="isCommentValidationRequired" name="isCommentValidationRequired"
                      v-model="modal.isCommentValidationRequired" class="mb-4 mt-2">
                    <label for="isCommentValidationRequired" class="ml-1"> {{ $t('label_modal_required') }} </label>
                  </div>
                  <LmTextInput ref="modalFontAwesomeIcon" v-model="modal.fontAwesomeIcon" :label="$t('label_modal_fontAwesomeIcon')"
                  placeholder="window-restore" :help="getHelp('lmModalActionsArgument', 'fontAwesomeIcon')" />
                  {{ $t('label_modal_fontAwesomeIcon_small') }} <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>
                  <!-- <LmTextInput ref="Modalcondition" v-model="modal.condition" label="condition" /> -->
                  <div class="col mb-3" v-if="false">
                  <div class="row ">
                  <LmTextInput ref="modalLeftHandSideValue" placeholder="Left value"   label="left hand side value" />
                  <LmSelect label="operator" class="mx-3" :options="{
                      content: [
                        { value: '===', text: '===' },
                        { value: '!==', text: '!==' },
                      ]
                    }" />
                  <LmTextInput ref="modalRightHandSideValue" placeholder="Right value"   label="right hand side value" />
                  </div>
                </div>
              </b-tab>
            </b-tabs>

            <LmButton type="button" buttonClass="btn-primary" :value="$t('btn_agregar_action')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-2 mb-0" lmButtonWrapperClass="col"
              @click.native="addActions" class="mb-3" />
            <h6 class="ml-3" v-if="form.lmPathActions.length && form.lmModalActions.length > 0">{{ $t('titulo_acciones') }}</h6>
            <draggable
              class="col-12"
              v-model="form.lmPathActions"
              @start="drag=true"
              @end="drag=false"
              animation="150"
              handle=".handle"
              @input="refreshListBuilder"
              >
              <!-- Draggable Actions -->
                <div v-for="(item, index) in form.lmPathActions" :key="index" class="mb-2">
                  <header  class="d-flex justify-content-between align-items-center bg-info text-white px-3 handle shadow rounded-lg">
                    <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                    <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-actions-${index}`"><font-awesome-icon :icon="item.fontAwesomeIcon" class='mr-2' /> {{ item.tooltip }}</h6>
                    <div class="circle d-none justify-content-center align-items-center">{{index}}</div>
                    <div class="d-flex align-items-center">
                      <font-awesome-icon v-b-toggle="`collapse-actions-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                      <font-awesome-icon  class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeElements(index, 'lmPathActions')" />
                    </div>
                  </header>
                  <b-collapse
           :id="`collapse-actions-${index}`"
          class="p-4 border border-top-0 rounded-lg"
          >
            <LmTextInput ref="to" v-model="form.lmPathActions[index].to" :label="$t('label_action_to')" :help="getHelp('lmPathActions', 'to')" @input="refreshListBuilder" />
            <LmTextInput ref="tooltip" v-model="form.lmPathActions[index].tooltip" :label="$t('label_action_tooltip')" :placeholder="$t('placeholder_action_tooltip')" :help="getHelp('lmPathActions', 'tooltip')" @input="refreshListBuilder" />
            <LmTextInput ref="font awesome icon" v-model="form.lmPathActions[index].fontAwesomeIcon" :label="$t('label_modal_fontAwesomeIcon')" :help="getHelp('lmPathActions', 'fontAwesomeIcon')" @input="refreshListBuilder"
              placeholder="edit" />
          </b-collapse>
                </div>
              </draggable>
          <h6 class="ml-3" v-if="form.lmModalActions.length && form.lmPathActions.length > 0">{{ $t('titulo_modals') }}</h6>
          <draggable
              class="col-12"
              v-model="form.lmModalActions"
              @start="drag=true"
              @end="drag=false"
              animation="150"
              handle=".handle"
              @input="refreshListBuilder"
              >
                <div v-for="(item, index) in form.lmModalActions" :key="index" class="mb-2">
                  <header  class="d-flex justify-content-between align-items-center bg-info text-white px-3 handle shadow rounded-lg">
                    <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                    <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-modals-${index}`"><font-awesome-icon :icon="item.fontAwesomeIcon" class='mr-2' /> {{ item.tooltip }}</h6>
                    <div class="circle d-none justify-content-center align-items-center">{{index}}</div>
                    <div class="d-flex align-items-center">
                      <font-awesome-icon v-b-toggle="`collapse-modals-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                      <font-awesome-icon  class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeElements(index, 'lmModalActions')" />
                    </div>
                  </header>
                  <b-collapse
           :id="`collapse-modals-${index}`"
          class="p-4 border border-top-0 rounded-lg"
          >
          <!-- Draggable Modals -->
            <LmTextInput ref="modalEndpoint" v-model="form.lmModalActions[index].endpoint" :placeholder="$t('placeholder_modal_endpoint')"  :label="$t('label_modal_endpoint')" :help="getHelp('lmModalActionsArgument', 'endpoint')" @input="refreshListBuilder" />
              <LmSelect v-model="form.lmModalActions[index].requestMethod" :label="$t('label_modal_requestMethod')" :options="{
                  disabledOption: $t('disabled_option'),
                  content: [
                    { value: 'POST', text: 'POST' },
                    { value: 'PUT', text: 'PUT' },
                    { value: 'DELETE', text: 'DELETE' }
                  ]
                }"
                :help="getHelp('lmModalActionsArgument', 'requestMethod')"
                @input="refreshListBuilder"
                />
              <LmNumberInputV2 ref="modalDelayAfterSubmit" v-model="form.lmModalActions[index].delayAfterSubmit" :placeholder="$t('placeholder_modal_delayAfterSubmit')"  :label="$t('label_modal_delayAfterSubmit')" :help="getHelp('lmModalActionsArgument', 'delayAfterSubmit')" @input="refreshListBuilder" />
              <LmTextInput ref="modalTitle" v-model="form.lmModalActions[index].title" :placeholder="$t('placeholder_modal_title')"  :label="$t('label_modal_title')" :help="getHelp('lmModalActionsArgument', 'title')" @input="refreshListBuilder" />
              <LmTextInput ref="modalTooltip" v-model="form.lmModalActions[index].tooltip" :placeholder="$t('placeholder_modal_tooltip')" :label="$t('label_modal_tooltip')" :help="getHelp('lmModalActionsArgument', 'tooltip')" @input="refreshListBuilder" />
              <LmEditor ref="modalMessage" @onUpdate="form.lmModalActions[index].message = $event" :contentProps="form.lmModalActions[index].message" :placeholder="$t('placeholder_modal_message')" :label="$t('label_modal_message')" :activeTable="false" :help="getHelp('lmModalActionsArgument', 'message')" @input="refreshListBuilder" />
              <input type="checkbox" id="isComment" name="isComment"
                v-model="form.lmModalActions[index].isComment" class="mb-4 mt-2" @input="refreshListBuilder">
              <label for="isComment" class="ml-1">{{ $t('label_isComment') }}</label>
              <div v-if="form.lmModalActions[index].isComment" class=" px-3">
                <LmTextInput ref="modalComment" v-model="form.lmModalActions[index].labelComment" :placeholder="$t('placeholder_modal_labelComment')" :label="$t('label_modal_labelComment')" :help="getHelp('lmModalActionsArgument', 'labelComment')" @input="refreshListBuilder" />
                <input type="checkbox" id="isCommentValidationRequired" name="isCommentValidationRequired"
                  v-model="form.lmModalActions[index].isCommentValidationRequired" class="mb-4 mt-2" @input="refreshListBuilder">
                <label for="isCommentValidationRequired" class="ml-1"> {{ $t('label_modal_required') }} </label>
              </div>
              <LmTextInput ref="modalFontAwesomeIcon" v-model="form.lmModalActions[index].fontAwesomeIcon" :label="$t('label_modal_fontAwesomeIcon')"
              placeholder="window-restore" :help="getHelp('lmModalActionsArgument', 'fontAwesomeIcon')" @input="refreshListBuilder" />
              {{ $t('label_modal_fontAwesomeIcon_small') }} <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>
          </b-collapse>
                </div>
              </draggable>
            </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-filters`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-filters`">{{ $t('titulo_ventana_aggregations') }}</h6>
              <b-badge variant="light" class="badge" v-if="form.aggs.length">{{ form.aggs.length }}</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-filters`"
          class="p-4 pl-4 py-3 border border-top-0 rounded-lg"
          >
            <div class="mt-2">
            <LmTextInput :label="$t('label_titulo')" v-model="aggs.key" :placeholder="$t('placeholder_título_filtro')" :help="$t('placeholder_título_filtro')" />
            <LmTreeSelect :label="$t('placeholder_columna')" :placeholder="$t('placeholder_columna')" @input="inputAggsField" v-model="aggsField" :options="dataField" :help="$t('help_ordenar_por')" />
            <LmNumberInputV2 :label="$t('Size')" :placeholder="$t('10')" v-model="aggs.value.terms.size" :help="$t('Cantidad a mostrar')" />
            <LmButton type="button" buttonClass="btn-primary" :value="$t('btn_agregar_aggregations')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-3" lmButtonWrapperClass="col"
              @click.native="addAggregations" />
              <draggable
              class="col-12"
              v-model="form.aggs"
              @start="drag=true"
              @end="drag=false"
              animation="150"
              handle=".handle"
              @change="inputDraggableAgregations"
              >
                <div v-for="(item, index) in form.aggs" :key="index" class="mb-2">
                  <header  class="d-flex justify-content-between align-items-center bg-info text-white px-3 handle shadow rounded-lg">
                    <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                    <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-aggs-${index}`">{{ item.key }}</h6>
                    <div class="circle d-none justify-content-center align-items-center">{{index}}</div>
                    <div class="d-flex align-items-center">
                      <font-awesome-icon v-b-toggle="`collapse-aggs-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                      <font-awesome-icon  class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeElements(index,'aggs')" />
                    </div>
                  </header>
                  <b-collapse
           :id="`collapse-aggs-${index}`"
          class="p-4 border border-top-0 rounded-lg"
          >
            <LmTextInput :label="$t('label_titulo')" v-model="form.aggs[index].key" @input="inputAggsStrings()" :placeholder="$t('placeholder_título_filtro')" :help="$t('placeholder_título_filtro')" />
            <LmTreeSelect :label="$t('placeholder_columna')" :placeholder="$t('placeholder_columna')" v-model="aggsVfor[index]" :options="dataField" @input="inputAggsVFor(index)" :help="$t('help_ordenar_por')" />
            <LmNumberInputV2 :label="$t('Size')" :placeholder="$t('10')" v-model="form.aggs[index].value.terms.size" :help="$t('Cantidad a mostrar')" @input="inputAggsStrings(index)" />
          </b-collapse>
                </div>
              </draggable>
            </div>
          </b-collapse>

          <header  class="d-flex bg-primary justify-content-between align-items-center text-white px-3 mt-3 handle shadow rounded-lg">
              <font-awesome-icon v-b-toggle="`collapse-modes`" class=" clickable" icon="chevron-down" style="width:16px; height:16px;" />
              <h6 class="flex-grow-1 text-center my-0 py-3 handle" v-b-toggle="`collapse-modes`">{{ $t('titulo_ventana_modo') }}</h6>
              <b-badge variant="light" class="badge d-none">0</b-badge>
              <div class="d-flex align-items-center"></div>
          </header>
          <b-collapse
          :id="`collapse-modes`"
          class="pl-4 py-3 border border-top-0 rounded-lg"
          >
            <div class="mt-2">

            <b-tabs content-class="mt-3" align="center">
              <b-tab :title="$t('label_modo_listado')" :active="form.mode.table" @click="clickTabsMode('table')"></b-tab>
              <b-tab :title="$t('label_modo_caja')" @click="clickTabsMode('box')" :active="form.mode.box">
                <div class="pt-2">
                  <LmTreeSelect :label="$t('label_titulo')" :placeholder="$t('placeholder_columna')" @input="inputModeBoxOptions(), addSearch()" v-model="boxTitle" :options="dataField" :clearable="true" />
                  <LmTreeSelect :label="$t('label_categoria')" :placeholder="$t('placeholder_columna')" @input="inputModeBoxOptions(), addSearch()" v-model="boxCategory" :options="dataField" :clearable="true" />
                  <LmTreeSelect :label="$t('label_contenido')" :placeholder="$t('placeholder_columna')" @input="inputModeBoxOptions(), addSearch()" v-model="boxContent" :options="dataField" :clearable="true" />
                  <LmTextInput v-model="boxPath" placeholder="/documentos/&#123;&#123;id&#125;&#125;/nuevo" label="Ruta" @input="inputModeBoxOptions" />
                  <LmNumberInputV2 v-model="boxCantCaractersTitle" placeholder="60" :label="$t('caracteres_titulo')" @input="inputModeBoxOptions(), addSearch()" />
                  <LmNumberInputV2 v-model="boxCantCaractersCategory" placeholder="60" :label="$t('caracteres_categoria')" @input="inputModeBoxOptions(), addSearch()" />
                  <LmNumberInputV2 v-model="boxCantCaractersContent" placeholder="60" :label="$t('caracteres_contenido')" @input="inputModeBoxOptions(), addSearch()" />
                  <LmTextInput v-model="boxMinHeight" placeholder="165px" :label="$t('alto_minimo')" @input="inputModeBoxOptions(), addSearch()" />

                  <LmSelect v-model="boxCantFilas" :label="$t('label_cantidad_filas')" @input="inputModeBoxOptions" :options="{
                        disabledOption: $t('disabled_option'),
                        content: [
                          { value: 'col-12', text: '1' },
                          { value: 'col-6', text: '2' },
                          { value: 'col-4', text: '3' },
                          { value: 'col-3', text: '4' },
                          { value: 'col-2', text: '6' }
                        ]
                      }"
                      />

                  <label for="option-center">Alineado</label>
                  <div id="option-center" class="option-center rounded">
                    <div class="top">
                      <div>
                        <b-button class="py-1 px-2" variant="outline-primary" :class="{ active: form.modeBoxOptions.justifyContent === 'flex-start' && form.modeBoxOptions.alignItems === 'flex-start'}" @click="clickAlineado('flex-start','flex-start','26px'), addSearch()">
                        <font-awesome-icon icon="angle-left" size="sm" />
                      </b-button>
                      </div>
                      <div>
                        <b-button class="py-1 px-2" variant="outline-primary" :class="{ active: form.modeBoxOptions.justifyContent === 'flex-start' && form.modeBoxOptions.alignItems === 'flex-end'}" @click="clickAlineado('flex-start','flex-end','26px'), addSearch()">
                        <font-awesome-icon icon="angle-right" size="sm" />
                      </b-button>
                      </div>
                    </div>
                    <div class="center">
                      <div>
                        <b-button class="py-1 px-2" variant="outline-primary" :class="{ active: form.modeBoxOptions.justifyContent === 'center' && form.modeBoxOptions.alignItems === 'center'}" @click="clickAlineado('center','center','14px'), addSearch()">
                        <font-awesome-icon icon="circle" size="sm" />
                      </b-button>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <b-button class="py-1 px-2" variant="outline-primary" :class="{ active: form.modeBoxOptions.justifyContent === 'flex-end' && form.modeBoxOptions.alignItems === 'flex-start'}" @click="clickAlineado('flex-end','flex-start','0px'), addSearch()">
                        <font-awesome-icon icon="angle-left" size="sm" />
                      </b-button>
                      </div>
                      <div>
                        <b-button class="py-1 px-2" variant="outline-primary" :class="{ active: form.modeBoxOptions.justifyContent === 'flex-end' && form.modeBoxOptions.alignItems === 'flex-end'}" @click="clickAlineado('flex-end','flex-end','0px'), addSearch()">
                        <font-awesome-icon icon="angle-right" size="sm" />
                      </b-button>
                      </div>
                    </div>
                  </div>

                  <label for="range-border" class="w-100">{{ $t('label_borde_superior') }}</label>

                  <input id="range-border" class="d-block" v-model="borderBox" @input="inputModeBoxOptions(), addSearch()" type="range" min="0" max="15" step="1">
                  <div class="mb-2">{{ borderBox }}px</div>

                  <label for="box-color">{{ $t('label_color_borde_superior') }}</label>
                  <swatches
                    id="box-color"
                    v-model="colorAcentBox"
                    :swatches="swatches"
                    :trigger-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
                    :swatch-style="{ width: '34px', height: '34px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
                    popover-to="left"
                    class="d-block mb-3"
                    show-fallback
                    @input="inputModeBoxOptions"
                    @close="addSearch"
                  ></swatches>
                  </div>
              </b-tab>
              <b-tab :title="$t('label_modo_mapa')" @click="clickTabsMode('map')" :active="form.mode.map"></b-tab>
            </b-tabs>
            </div>
          </b-collapse>

          <!-- ----- -->

          <LmButton type="submit" buttonClass="btn-secondary" :value="$t('cancel')"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-2" lmButtonWrapperClass="col"
            @click="$router.back()" :isProcessing="isProcessing"
            />

          <LmButton type="button" buttonClass="btn-primary" :value="$t('save')"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-2" lmButtonWrapperClass="col"
            @click.native="submit" :isProcessing="isProcessing"
            />
            <div class="border d-block mt-3 p-3 mb-0 " v-if="this.currentID">
            <router-link :to="{ path: '/listbuilder/view/'+ this.currentID }" class="d-block text-monospace">
            {{ $t('ver_el_ultimo_cargado') }}
            </router-link>
            <router-link :to="{ path: '/listbuilder/view/' + this.listadoID }" class="d-block mt-1 text-monospace">
              <font-awesome-icon icon="list-alt" class="" /> {{ $t('listado_de_listado') }}
            </router-link>
            </div>
        </div>
      </div>
    </div>
<!-- :class="!dataOriginSelected ? 'sombra' : ''" -->
    <div class="text-dark pt-3 mt-3 title-preview" v-if="dataOriginSelected">
      <hr>
      <!-- <div class="wrapper-content w-100 position-relative">
        <font-awesome-icon icon="list" class="mr-1 text-primary" /> {{ $t('titulo_ventana_preview') }}
      </div> -->
    </div>

      <LmListV2 v-if="dataOriginSelected" ref="LmListV2" :isGraphql="isGraphql"
        :gqlField="form.gqlField" :gqlVariables="form.gqlVariables" :gqlQuery="form.gqlQuery"
        :searchOnFieldsSelected="form.searchOnFieldsSelected"
        :searchOnFieldsToSelected="form.searchOnFieldsToSelected"
        :items="form.items"
        :mode="form.mode"
        :allAvailableFields="form.fields"
        :isOnEditMode="true"
        :key="key"
        :listBuilderTitleList="listBuilderTitleList"
        :listBuilderButtons="listBuilderButtons"
        :modeBoxOptions="form.modeBoxOptions"
        @updateDescriptionFields="updateDescriptionFields"
        :selectable="form.selectable"
        class="my-4"
        />

    <LmError v-if="!dataOriginSelected" title="Seleccione el origen de datos"
      subtitle="Comience seleccionando el origen de datos para previsualizar la tabla" />

  </div>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import commonsApi from '@/api/commons'
import LmListV2 from '@/components/LmListV2.vue'
import LmTextInput from '@/components/form/elements/LmTextInput.vue'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2.vue'
import LmError from '@/components/LmError.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'
import lmToasts from '@/mixins/lmToasts.js'
import LmSelect from '@/components/form/elements/LmSelect.vue'
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import draggable from 'vuedraggable'

import LmQueryBuilder from '@/components/lmQueryBuilder'

export default {
  mixins: [lmToasts],
  components: {
    LmListV2,
    LmTextInput,
    LmNumberInputV2,
    LmError,
    LmButton,
    Swatches,
    LmSelect,
    LmEditor,
    LmTextArea,
    draggable,
    LmTreeSelect,
    LmQueryBuilder,
    LmCheckbox
  },
  props: {
    isGraphql: {
      type: Boolean,
      default: false
    },
    gqlQuery: {
      type: String,
      default: ''
    },
    gqlSchema: {
      type: String,
      default: ''
    },
    gqlField: {
      type: String,
      default: ''
    },
    gqlVariables: {
      type: Object
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      queryBuilderSettings: [],
      dataOrigin: [],
      dataOriginSelected: null,
      dataOriginSelectedDefault: '',
      dataSchemaGraphql: '',
      dataSort: [],
      dataField: [],
      isProcessing: false,
      aggsVfor: [],
      help: {},
      showButton: {},
      currentID: '',
      listadoID: '600f360aed518edeaa897095',
      dataSortSelected: { id: 'updatedAt__desc', name: 'updatedAt__desc' },
      boxTitle: null,
      boxCategory: null,
      boxContent: null,
      boxCantFilas: 'col-3',
      boxPath: '/documentos/{{id}}/nuevo',
      boxCantCaractersTitle: 60,
      boxCantCaractersCategory: 60,
      boxCantCaractersContent: 60,
      boxMinHeight: '165px',
      defaultDataSortSelected: '',
      arrayEmplyItems: [],
      swatches: [{ color: '#007bff' }, { color: '#6c757d' }, { color: '#17a2b8' }, { color: '#28a745' }, { color: '#ffc107' }, { color: '#dc3545' }, { color: '#343a40' }],
      colorAcentBox: '#007bff',
      borderBox: 6,
      buttons: {
        value: '',
        to: '',
        endpointToValidateVisibility: '',
        show: true,
        disabled: false,
        buttonClass: '',
        buttonColor: '#17a2b8',
        enableOnSelectedRows: false,
        type: 'redirect',
        requestEndpoint: '',
        requestConfirmation: false
      },
      action: {
        to: `${this.$t('placeholder_action_to')}`,
        tooltip: '',
        fontAwesomeIcon: ''
      },
      modal: {
        endpoint: '',
        title: '',
        message: '',
        isComment: false,
        isCommentValidationRequired: false,
        labelComment: '',
        successMessage: '',
        fontAwesomeIcon: '',
        tooltip: '',
        requestMethod: '',
        delayAfterSubmit: 0
        // condition: {}
      },
      count: 0,
      key: 0,
      aggs: {
        key: '',
        value: {
          terms: {
            field: '',
            size: 10
          }
        }
      },
      aggsField: null,
      refresh: null,
      timeToRefresh: 1000,
      form: {
        alias: '',
        titleList: '',
        gqlField: '',
        gqlQuery: '',
        gqlVariables: {
          q: '*',
          sort: 'updatedAt__desc',
          page: 1
        },
        metaSearch: '*',
        lmPathActions: [],
        lmModalActions: [],
        searchOnFieldsSelected: [],
        searchOnFieldsToSelected: [],
        visibleFields: [],
        allAvailableFields: [],
        fields: [],
        newFields: [],
        items: {},
        buttonLinks: [],
        page: 1,
        itemsPerPage: 10,
        mode: {
          table: true,
          map: false,
          box: false
        },
        action: {
          lmPathActions: true,
          lmModalActions: false
        },
        modeBoxOptions: {
          title: '',
          category: '',
          content: '',
          path: '/documentos/{{id}}/nuevo',
          boxCantFilas: '',
          borderBox: '',
          colorAcentBox: '',
          cantCaractersCategory: 60,
          cantCaractersTitle: 60,
          cantCaractersContent: 60,
          minHeight: '165px',
          justifyContent: 'flex-start',
          alignItems: 'flex-start'
        },
        aggs: [],
        selectable: false
      },
      listBuilderTitleList: '',
      listBuilderButtons: []
    }
  },
  computed: {
    computedButtonClass: function () {
      let buttonClass = ''
      if (this.buttons.buttonColor === '#007bff') buttonClass = 'btn-primary'
      if (this.buttons.buttonColor === '#6c757d') buttonClass = 'btn-secondary'
      if (this.buttons.buttonColor === '#17a2b8') buttonClass = 'btn-info'
      if (this.buttons.buttonColor === '#28a745') buttonClass = 'btn-success'
      if (this.buttons.buttonColor === '#ffc107') buttonClass = 'btn-warning'
      if (this.buttons.buttonColor === '#dc3545') buttonClass = 'btn-danger'
      if (this.buttons.buttonColor === '#343a40') buttonClass = 'btn-dark'
      return buttonClass
    }
  },
  watch: {
    listBuilderTitleList () {
      this.form.titleList = this.listBuilderTitleList
    },
    'form.fields': {
      immediate: false,
      deep: true,
      handler (val, oldVal) {
        if (this.count === 1 && !this.isOnEditMode) {
          this.form.allAvailableFields = this.form.fields
        }
      }
    },
    async 'form.gqlField' (val) {
      if (val) {
        const arr = []
        const res = await commonsApi.axiosGetWrapper(`/listbuilder/finder/service/${val}`)
        for (const item of this.form.items) {
          if (res.data.hasOwnProperty(item.name)) {
            arr.push({ ...res.data[item.name], name: item.name })
          }
        }
        this.queryBuilderSettings = arr
      }
    }
  },
  methods: {
    clickAlineado (justifyContent, alignItems, paddingTop) {
      this.form.modeBoxOptions.justifyContent = justifyContent
      this.form.modeBoxOptions.alignItems = alignItems
      this.form.modeBoxOptions.paddingTop = paddingTop
    },
    clickTabsActions (value) {
      if (value === 'lmPathActions') {
        this.form.action = {
          lmPathActions: true,
          lmModalActions: false
        }
      } else if (value === 'lmModalActions') {
        this.form.action = {
          lmPathActions: false,
          lmModalActions: true
        }
      }
    },
    clickTabsMode (value) {
      if (value === 'table') {
        this.form.mode = {
          table: true,
          map: false,
          box: false
        }
      } else if (value === 'map') {
        this.form.mode = {
          table: false,
          map: true,
          box: false
        }
      } else if (value === 'box') {
        this.form.mode = {
          table: false,
          map: false,
          box: true
        }
      }
      this.addSearch()
    },
    updateDescriptionFields (index, field, event) {
      let itemIndex = this.form.items.findIndex(item => item.name === field.key)
      let dataFieldIndex = this.dataField.findIndex(item => item.id === field.key)
      this.form.items[itemIndex].description = event
      this.dataField[dataFieldIndex].name = event
    },
    nameColumn (name, description) {
      // buscar key en fields
      let res = null
      let field = this.form.allAvailableFields.find(item => item.key === name)
      if (field?.label === description) {
        res = field?.label
      } else {
        res = description
      }
      return res
    },
    onTableSelectable () {
      this.refreshListBuilder()
    },
    onUpdateGqlVariablesQ (event) {
      this.form.gqlVariables.q = event.build
      this.refreshListBuilder()
    },
    onUpdateMetaSearch (event) {
      this.form.metaSearch = event.build
      this.refreshListBuilder()
    },
    inputAggsVFor (index) {
      if (this.form.aggs[index].value.terms?.field) {
        this.form.aggs[index].value.terms.field = this.aggsVfor[index]?.id
      }
      this.refreshListBuilder()
    },
    inputDraggableAgregations () {
      this.refreshListBuilder()
    },
    inputButtonColor (index) {
      let color = this.form.buttonLinks[index].buttonColor
      let buttonClass = null
      if (color === '#007bff') buttonClass = 'btn-primary'
      if (color === '#6c757d') buttonClass = 'btn-secondary'
      if (color === '#17a2b8') buttonClass = 'btn-info'
      if (color === '#28a745') buttonClass = 'btn-success'
      if (color === '#ffc107') buttonClass = 'btn-warning'
      if (color === '#dc3545') buttonClass = 'btn-danger'
      if (color === '#343a40') buttonClass = 'btn-dark'
      this.form.buttonLinks[index].buttonClass = buttonClass
      this.refreshListBuilder()
    },
    valueFilter (value) {
      const res = {
        id: value,
        name: value
      }
      return res
    },
    inputAggsStrings () {
      this.refreshListBuilder()
    },
    inputSelectAggsStrings (index) {
      if (this.form.aggs[index].value.terms.field.name) {
        this.form.aggs[index].value.terms.field = this.form.aggs[index].value.terms.field.name
      }
      this.refreshListBuilder()
    },
    defaultValue (field) {
      return {
        id: field,
        name: field
      }
    },
    refreshListBuilder () {
      clearTimeout(this.refresh)
      this.refresh = setTimeout(() => {
        this.key++
        this.initialOriginData()
      }, this.timeToRefresh)
    },
    removeElements (index, key) {
      this.form[key].splice(index, 1)
      this.key++
      this.initialOriginData()
    },
    // Asigna variables en el evento input, en campos modo caja
    inputModeBoxOptions () {
      this.form.modeBoxOptions.title = this.boxTitle?.id
      this.form.modeBoxOptions.category = this.boxCategory?.id
      this.form.modeBoxOptions.content = this.boxContent?.id
      this.form.modeBoxOptions.boxCantFilas = this.boxCantFilas
      this.form.modeBoxOptions.colorAcentBox = this.colorAcentBox
      this.form.modeBoxOptions.borderBox = this.borderBox
      this.form.modeBoxOptions.path = this.boxPath
      this.form.modeBoxOptions.cantCaractersTitle = this.boxCantCaractersTitle
      this.form.modeBoxOptions.cantCaractersCategory = this.boxCantCaractersCategory
      this.form.modeBoxOptions.cantCaractersContent = this.boxCantCaractersContent
      this.form.modeBoxOptions.minHeight = this.boxMinHeight
    },
    // Evento input, en campo "ordenar por"
    inputSortData () {
      let sort = this.dataSortSelected?.name
      this.form.gqlVariables.sort = sort
      this.key++
      this.initialOriginData()
    },
    // Evento input, en campo "origen de datos"
    inputOriginData () {
      this.form.alias = ''
      if (!this.isOnEditMode) this.form.titleList = ''
      if (!this.isOnEditMode) this.listBuilderTitleList = ''
      this.form.lmPathActions = []
      this.form.lmModalActions = []
      this.form.buttonLinks = []
      this.form.page = 1
      this.form.itemsPerPage = 10
      if (!this.isOnEditMode) {
        this.form.gqlVariables.q = '*'
        this.form.metaSearch = '*'
        this.form.gqlVariables.sort = 'updatedAt__desc'
        this.dataSortSelected = {
          id: 'updatedAt__desc',
          name: 'updatedAt__desc'
        }
      }
      this.form.aggsField = {}
      this.aggs = {
        key: '',
        value: {
          terms: {
            field: '',
            size: 10
          }
        }
      }
      this.form.aggs = []
      this.form.fields = []
      this.count = 0
      this.key++
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({})
      }
      this.form.mode = {
        table: true,
        map: false,
        box: false
      }
      this.boxTitle = ''
      this.boxCategory = ''
      this.boxContent = ''
      this.initialOriginData('inputOriginData')
    },
    // Evento click, en "aplicar botón"
    addButonLink () {
      if (this.buttons?.value) {
        this.buttons.buttonClass = this.computedButtonClass
        this.form.buttonLinks.push({ ...this.buttons })
        this.buttons.to = ''
        this.buttons.value = ''
        this.buttons.endpointToValidateVisibility = ''
        this.buttons.show = true
        this.buttons.disabled = false
        this.buttons.buttonColor = '#17a2b8'
        this.key++
        this.initialOriginData()
      }
    },
    // Evento click, en "eliminar botón"
    deleteButtons (index) {
      this.form.buttonLinks.splice(index, 1)
      this.key++
      this.initialOriginData()
    },
    // Evento click, en "aplicar busqueda"
    addSearch () {
      this.form.gqlVariables.q = this.form.gqlVariables?.q || '*'
      this.form.metaSearch = this.form?.metaSearch || '*'
      this.key++
      this.initialOriginData()
    },
    // Evento click, en "aplicar acciones"
    async addActions () {
      if (this.form.action.lmPathActions === true) {
        if (this.action?.to && this.action?.tooltip && this.action?.fontAwesomeIcon) {
          this.form.lmPathActions.push({ ...this.action })
          this.action.tooltip = ''
          this.action.fontAwesomeIcon = ''
          this.key++
          this.initialOriginData()
        }
      }
      if (this.form.action.lmModalActions === true) {
        if (this.modal?.endpoint && this.modal?.title && this.modal?.tooltip && this.modal?.fontAwesomeIcon) {
          this.modal.delayAfterSubmit = parseInt(this.modal.delayAfterSubmit)
          this.form.lmModalActions.push({ ...this.modal })
          this.modal.endpoint = ''
          this.modal.title = ''
          this.modal.tooltip = ''
          this.$refs.modalMessage.editor.commands.clearContent()
          this.modal.message = ''
          this.modal.isComment = false
          this.modal.isCommentValidationRequired = false
          this.modal.labelComment = ''
          this.modal.successMessage = ''
          this.modal.fontAwesomeIcon = ''
          this.modal.requestMethod = ''
          this.modal.delayAfterSubmit = 0
          this.key++
          this.initialOriginData()
        }
      }
    },
    // Evento click, en "eliminar acciones"
    deleteActions (index, type) {
      if (type === 'path') this.form.lmPathActions.splice(index, 1)
      if (type === 'modal') this.form.lmModalActions.splice(index, 1)
      this.key++
      this.initialOriginData()
    },
    // Evento click, en "Guardar"
    async submit () {
      try {
        if (this.isOnEditMode) {
          this.initialOriginData()
          const response = await commonsApi.axiosPutWrapper(`listbuilder/${this.$route.params.id}`, this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/listbuilder/view/${this.currentID}`, 'Puedes ver el listado aquí', 'Se guardó exitosamente')
        } else {
          this.isProcessing = true
          const response = await commonsApi.axiosPostWrapper('listbuilder/create', this.form)
          this.currentID = response.data.id
          setTimeout(() => {
            this.$router.push(`/listbuilder/edit/${this.currentID}`)
          }, 650)
        }
      } finally {
        this.isProcessing = false
      }
    },
    // Obtiene ayuda de la introspección
    getHelpData () {
      let lmModalActionsArgumentToHelp = ''
      let lmPathActionsToHelp = ''
      let lmButtonLinkArgumentToHelp = ''

      // usado para obtener las descripciones de los campos en los resolvers
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmModalActionsArgument') {
          lmModalActionsArgumentToHelp = value.type.ofType.inputFields
        }
      })
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmPathActionArgument') {
          lmPathActionsToHelp = value.type.ofType.inputFields
        }
      })
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name === 'lmButtonLinkArgument') {
          lmButtonLinkArgumentToHelp = value.type.ofType.inputFields
        }
      })
      this.help.lmModalActionsArgument = lmModalActionsArgumentToHelp
      this.help.lmPathActions = lmPathActionsToHelp
      this.help.lmButtonLink = lmButtonLinkArgumentToHelp
    },
    // Retorna la ayuda del resolver y el campo seleccionado
    getHelp (resolver, fieldname) {
      return this.$t(this.help[resolver]?.find(field => field.name === fieldname).description)
    },
    // Remplaza comillas en los keys, cuando lo convertimos a string
    replaceQuote (val) {
      return JSON.stringify(val).replace(/"([^"]+)":/g, '$1:')
    },
    replaceLastQuotes (str, search, replace, n) {
      str = this.reverseString(str)
      while (--n + 1) {
        str = str.replace(search, replace)
      }
      str = this.reverseString(str)
      return str
    },
    reverseString (str) {
      const arr = str.split('')
      const stringReversed = arr.reduce((reversed, character) => {
        return character + reversed
      }, '')
      return stringReversed
    },
    // Evento input, en campo "Columnas" en filtro
    inputAggsField () {
      this.aggs.value.terms.field = this.aggsField?.id
    },
    // Evento click, en "Aplicar filtros"
    addAggregations () {
      if (this.aggs.key && this.aggs.value.terms.field && this.aggs.value.terms.size) {
        this.form.aggs.push({
          key: this.aggs.key,
          value: {
            terms: {
              field: this.aggs.value.terms.field,
              size: this.aggs.value.terms.size
            }
          }
        })
        this.aggsVfor.push({
          id: this.aggs.value.terms.field,
          name: this.aggs.value.terms.field
        })
        this.aggs.key = ''
        this.aggsField = null
        this.aggs.value.terms.field = ''
        this.aggs.value.terms.size = 10
        this.refreshListBuilder()
      }
    },
    // Transforma los aggregations en string
    aggsToString () {
      let aggsToString = ''
      _.forEach(this.form.aggs, function (value, key) {
        aggsToString += `{key: "${value.key}" value:{terms:{field:${value.value.terms.field} size:${value.value.terms.size}}}}`
      })
      return aggsToString
    },
    // Origen de datos inicial, se genera el gqlQuery que toma LmListV2
    initialOriginData (loadFromMethod) {
      let sort = ''
      let items = ''
      let item = ''
      let fieldSelected = []
      this.arrayEmplyItems = []
      // get name of field sort
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name.substr(-8) === 'SortEnum') {
          sort = value.type.ofType.name
        }
      })
      this.getHelpData()
      if (!this.isOnEditMode) {
        const table = _.filter(this.dataOriginSelected.fields, ['name', 'table'])
        items = _.filter(table[0]?.type?.fields, ['name', 'items'])
        items = items[0]?.type?.ofType?.fields
        this.form.items = items
      }
      let emplyItems = {}
      _.forEach(items, function (value, key) {
        item += value.name + ' '
        emplyItems[value.name] = ' '
        fieldSelected.push(value.name)
      })
      this.arrayEmplyItems.push(emplyItems)
      items = item
      if (loadFromMethod === 'inputOriginData') {
        this.form.searchOnFieldsSelected = fieldSelected
        this.form.searchOnFieldsToSelected = fieldSelected
        this.form.visibleFields = fieldSelected
        this.form.gqlVariables.q = '*'
        this.form.metaSearch = '*'
      }
      let lmPathActions = this.replaceQuote(this.form.lmPathActions)
      let lmModalActions = this.replaceQuote(this.form.lmModalActions)
      let buttonLinks = this.replaceQuote(this.form.buttonLinks)
      this.form.gqlField = this.dataOriginSelected.name

      // Se cargan en this.dataSort los campos de ordenamiento
      this.getDataSort()
      if (this.count === 1 && !this.isOnEditMode) {
        this.form.allAvailableFields = this.form.fields
      }
      // Chequeo si existe updatedAt__desc, si no existe lo cambio por '_score'
      const evenDataSort = (a) => a.id === 'updatedAt__desc'
      const isDataSort = this.dataSort.some(evenDataSort)
      if (!isDataSort && this.count === 0 && !this.isOnEditMode) {
        this.form.gqlVariables.sort = '_score'
        this.dataSortSelected = {
          id: '_score',
          name: '_score'
        }
      }
      this.form.newFields = this.form.fields
      const valuesToRemove = this.form.visibleFields
      const filteredItems = this.form.newFields.filter(item => valuesToRemove.includes(item.key))
      this.form.newFields = filteredItems
      if (this.form.visibleFields.length > this.form.newFields.length && this.form.newFields.length > 0 && this.isOnEditMode) {
        const valuesToAdd = this.form.visibleFields
        const filteredItems = this.form.visibleFields.filter(item => valuesToAdd.includes(item.key))
        this.form.newFields = filteredItems
      }
      // Columnas para los superpowers modo caja
      let dataField = []
      _.forEach(this.form.items, function (value, key) {
        dataField.push({ id: value.name, name: value.description })
      })
      if (this.count === 0) {
        this.dataField = dataField
      }

      this.form.titleList = this.listBuilderTitleList
      // queryGraphql
      this.form.gqlQuery = `query($page:Int, $q:String, $sort:[${sort}]) {
      ${this.form.gqlField}(
          titleList: ${this?.form?.titleList ? '"' + this?.form?.titleList + '"' : '" "'}
          aggs: [${this.aggsToString()}]
          q: $q
          perPage: ${this?.form?.itemsPerPage ? this?.form?.itemsPerPage : 10}
          page: $page
          sort: $sort
          metaSearch: "${this?.form?.metaSearch ? this?.form?.metaSearch : '*'}"
          opts: {
            lenient: true
          }
          lmPathActions: ${this?.form?.lmPathActions.length > 0 ? lmPathActions : '[]'}
          lmModalActions: ${this?.form?.lmModalActions.length > 0 ? lmModalActions : '[]'}
          buttonLinks: ${this?.form?.buttonLinks.length > 0 ? buttonLinks : '[]'}
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          itemsPerPage
          table {
            items {
              ${this.form?.visibleFields}
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`
      this.form.gqlVariables = {
        q: this?.form?.gqlVariables.q,
        sort: this.form?.gqlVariables?.sort ? this?.form?.gqlVariables?.sort : 'updatedAt__desc',
        page: this?.form?.page ? this?.form?.page : 1
      }
      this.count++
    },
    // Devuelve valores guardados en onEditMode
    async getListValues () {
      try {
        this.isDataProcessing = true
        const endPoint = await commonsApi.axiosGetWrapper(`listbuilder/${this.$route.params.id}`)
        this.form.gqlQuery = endPoint.data.gqlQuery
        this.dataOriginSelected = this.dataOrigin.filter(dataOrigin => dataOrigin.name === `${endPoint.data.gqlField}`)
        this.dataOriginSelected = this.dataOriginSelected[0]
        this.form.gqlVariables = endPoint.data.gqlVariables
        this.form.metaSearch = endPoint.data?.metaSearch
        this.getDataSort()
        this.dataSortSelected = { id: endPoint.data.gqlVariables.sort, name: endPoint.data.gqlVariables.sort }
        this.form.titleList = endPoint.data.titleList
        this.form.alias = endPoint.data.alias
        this.form.gqlField = endPoint.data.gqlField
        this.form.buttonLinks = endPoint.data.buttonLinks
        this.form.lmPathActions = endPoint.data.lmPathActions
        this.form.lmModalActions = endPoint.data.lmModalActions
        this.form.searchOnFieldsSelected = endPoint.data.searchOnFieldsSelected
        this.form.searchOnFieldsToSelected = endPoint.data.searchOnFieldsToSelected
        this.form.items = endPoint.data.items
        this.form.itemsPerPage = endPoint.data.itemsPerPage
        this.form.page = endPoint.data.page
        if (this.form.items) {
          this.form.items = this.dataOriginSelected.fields.filter(el => el.name === 'table')[0].type.fields.filter(el => el.name === 'items')[0].type.ofType.fields
        }
        this.form.newFields = endPoint.data.fields
        let fields = this.form.newFields.map(el => {
          return el.key
        })
        this.form.visibleFields = fields
        this.form.mode = endPoint.data.mode
        this.listBuilderTitleList = endPoint.data.titleList
        this.listBuilderButtons = endPoint.data.buttonLinks
        this.form.aggs = endPoint.data.aggs
        this.form.selectable = endPoint.data?.selectable || false
        let aggsVfor = []
        _.forEach(endPoint.data?.aggs, function (value, key) {
          aggsVfor.push({
            id: value.value.terms.field,
            name: value.value.terms.field
          })
        })
        this.aggsVfor = aggsVfor
        if (endPoint?.data?.modeBoxOptions) this.form.modeBoxOptions = endPoint?.data?.modeBoxOptions
        // Fields para mostrar en el superpower en modo caja
        const dataField = []
        _.forEach(this.form.items, function (value, key) {
          dataField.push({ id: value.name, name: value.description })
        })
        this.dataField = dataField
        // Grupo de variables modo caja
        this.boxTitle = endPoint?.data?.modeBoxOptions?.title ? {
          id: endPoint.data?.modeBoxOptions?.title,
          name: endPoint.data?.modeBoxOptions?.title
        } : null
        this.boxCategory = endPoint?.data?.modeBoxOptions?.category ? {
          id: endPoint.data?.modeBoxOptions?.category,
          name: endPoint.data?.modeBoxOptions?.category
        } : null
        this.boxContent = endPoint?.data?.modeBoxOptions?.content ? {
          id: endPoint.data?.modeBoxOptions?.content,
          name: endPoint.data?.modeBoxOptions?.content
        } : null
        this.boxPath = endPoint.data?.modeBoxOptions?.path
        this.boxCantFilas = endPoint?.data?.modeBoxOptions?.boxCantFilas || 'col-3'
        this.borderBox = endPoint.data?.modeBoxOptions?.borderBox || 6
        this.colorAcentBox = endPoint.data?.modeBoxOptions?.colorAcentBox || '#007bff'
        this.boxCantCaractersTitle = endPoint.data?.modeBoxOptions?.cantCaractersTitle || 60
        this.boxCantCaractersCategory = endPoint.data?.modeBoxOptions?.cantCaractersCategory || 60
        this.boxCantCaractersContent = endPoint.data?.modeBoxOptions?.cantCaractersContent || 60
        this.boxMinHeight = endPoint.data?.modeBoxOptions?.minHeight || '165px'
        this.form.modeBoxOptions.justifyContent = endPoint.data?.modeBoxOptions?.justifyContent || 'flex-start'
        this.form.modeBoxOptions.alignItems = endPoint.data?.modeBoxOptions?.alignItems || 'flex-start'
        this.form.modeBoxOptions.paddingTop = endPoint.data?.modeBoxOptions?.paddingTop || '26px'
      } catch (error) {
        console.log(error)
        // this.$router.push('/')
      } finally {
        // hay que esperar que renderice para pisar form.fields que viene de la consulta gql
        // para que se visualice el nombre de fantasía en las columnas de lmListV2
        if (this.isOnEditMode) {
          this.form.fields = this.form.newFields
        }
        this.isDataProcessing = false
      }
    },
    getDataSort () {
      let enumDataSort = this?.dataOriginSelected.args[2]?.type?.ofType?.enumValues
      let dataSort = []
      _.forEach(enumDataSort, function (value, key) {
        dataSort.push({ id: value.name, name: value.name })
      })
      this.dataSort = dataSort
    }
  },
  async mounted () {
    if (this.isGraphql) {
      try {
        this.dataSchemaGraphql = await this.$apollo.query({ query: gql`${this.gqlSchema}` })
        let initialDataOrigin = []
        // get origin data and args
        _.forEach(this.dataSchemaGraphql.data.__schema.queryType.fields, function (value, key) {
          initialDataOrigin.push({
            id: key,
            args: value.args,
            name: value.name,
            fields: value.type.fields
          })
        })
        this.dataOrigin = initialDataOrigin
        if (this.isOnEditMode) {
          await this.getListValues()
        }
      } catch (e) {
        console.log('graphQlAllErrors:', JSON.stringify(e))
        console.log('graphQlNetworkError:', JSON.stringify(e.networkError))
        console.log('graphQlErrors:', JSON.stringify(e.graphQLErrors))
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.option-center
  display: flex
  align-items: flex-start
  justify-content: flex-start
  flex-direction: column
  max-width: 112px
  min-height: 112px
  border: 1px solid #aaa
  border-style: dashed
  padding: 11px
  transform: scale(0.75) //zoom: 0.8
  transform-origin: left top
  margin-bottom: -11px
  .top
    width: 100%
    display: flex
    justify-content: space-between
  .center
    width: 100%
    display: flex
    justify-content: center
  .bottom
    width: 100%
    display: flex
    justify-content: space-between
  button
    border: 0
  button.active button:active
    background: #007bff !important
    color: #fff
    border: 0
    outline: 0
.sombra
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
.sombra-preview
  box-shadow: 0 0rem 2.5rem rgba(0, 0, 0, 0.09)
.badge
  font-size: 14px !important
  border-radius: 50px !important
.title-preview
  font-size: 15px
</style>
